import { render, staticRenderFns } from "./BugTrackerAdminControls.vue?vue&type=template&id=9d4afed4&scoped=true&"
import script from "./BugTrackerAdminControls.vue?vue&type=script&lang=ts&"
export * from "./BugTrackerAdminControls.vue?vue&type=script&lang=ts&"
import style0 from "./BugTrackerAdminControls.vue?vue&type=style&index=0&id=9d4afed4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d4afed4",
  null
  
)

export default component.exports